import { API_BASE_URL } from 'api/config';
import {createAxios} from './axios';

const zoomApi = createAxios({
    baseURL: API_BASE_URL + '/appointments'
});

export const postTelehealthAppointment = (appointmentId) => {
    return zoomApi.get(`/${appointmentId}/zoom-meeting/join-url`);
};